import { FileChecksum } from "@rails/activestorage/src/file_checksum";
import { fileTypeFromBlob } from "file-type";

export const directUploadFileParamsFor = async file => {
  const checksum = await generateCheckSum(file);

  // Use the `file-type` library to detect the actual mime type of the file, but fallback
  // to the browser-provided file type (from the extension) if not available (like text
  // based file types for example). This allows avoiding bad renamed binary files as
  // input but isn't bulletproof. Note that a bulletproof solution can't be front-end only
  // as an attacker could easily forge a malicious request bypassing this check.
  //
  const fileType = await fileTypeFromBlob(file);
  const { mime: content_type = file.type } = fileType || {};

  return {
    filename: file.name,
    byte_size: file.size,
    content_type,
    checksum
  };
};

// Generate a checksum for the file to be sent to the server, to allow ActiveStorage to
// build the direct upload signature and ensure that the file is not corrupted during
// the upload process.
export const generateCheckSum = file => {
  return new Promise((resolve, reject) => {
    FileChecksum.create(file, (error, checksum) => {
      error ? reject(error) : resolve(checksum);
    });
  });
};
